import React from "react";
import PivotGrid, { FieldChooser } from "devextreme-react/pivot-grid";
import ChartCard from "components/common/pyramid/ChartCard";

const PyramidPivotGrid = ({
  pivotGridRef,
  dataSource,
  palette,
  onContentReady,
  title = " ",
}) => {
  const pivotGridConfig = {
    allowSortingBySummary: true,
    allowFiltering: true,
    showBorders: true,
    showColumnGrandTotals: true,
    showRowGrandTotals: true,
    showRowTotals: true,
    showColumnTotals: true,
    height: "auto",
    export: {
      enabled: false,
    },
    fieldChooser: {
      enabled: true,
      allowSearch: true,
    },
    scrolling: {
      mode: "virtual",
    },
    palette: palette,
  };

  return (
    <ChartCard
      title={title}
      pivotGridRef={pivotGridRef}
      className="h-auto"
      palette={palette}
    >
      <div className="px-3">
        {dataSource && (
          <PivotGrid
            ref={pivotGridRef}
            id="pivotgrid"
            dataSource={dataSource}
            {...pivotGridConfig}
            onContentReady={onContentReady}
          >
            <FieldChooser enabled={true} allowSearch={true} />
          </PivotGrid>
        )}
      </div>
    </ChartCard>
  );
};

export default PyramidPivotGrid;
